import { fetchProxyPool } from '@fd/common/api/fetchProxyPool';
import useSWR from 'swr';

export default function usePoolById(poolId: number) {
  const query = useSWR(['pool', poolId], () => {
    return fetchProxyPool(poolId);
  });

  return query;
}
